// extracted by css-extract-rspack-plugin
export default {"linkUnderlined":"CompanyNameCheckHint_linkUnderlined__C7ZcG"};